// Define prop types for the component
import { ButtonPropsColorOverrides } from '@mui/material/Button/Button';
import { OverridableStringUnion } from '@mui/types';

import { FormattedAppointment } from 'FRONTEND/utils/backendApi/Appointments/appointment.types';

export type VideoConfButtonProps = {
  color?: OverridableStringUnion<
    'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    ButtonPropsColorOverrides
  >
  appointment: FormattedAppointment;
  fullButton?: boolean;
  hideIcon?: boolean;
  rtcServerUrl: string;
}

// Enum for strategy values
export enum Strategy {
  COPY = 'COPY',
  OPEN = 'OPEN',
}

// Type for handleGenerateLink parameters
export type HandleGenerateLinkParams = {
  strategy?: Strategy;
  isGuest?: boolean;
  linkType?: 'practitioner' | 'patient';
}
